"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function debugLog(message, ...args) {
    if (process.env.IAM_DEBUG === 'true') {
        console.info(`[IAM] ${JSON.stringify(message)}`, ...args.map((arg) => JSON.stringify(arg)));
    }
}
exports.default = debugLog;
//# sourceMappingURL=debugLog.js.map